import React from 'react'
import { Cointainer, CustomNavLink, CustomNavLink1 } from '../../style/MobileSidebar'
import { CustomDiv } from '../../style/shared'
import './sidebar.css';

export const Sidebar = ({ config }) => {
    const renderNavLink = (item, isActive) => {
        return (
            <CustomNavLink to={item.path} className={isActive ? 'active' : ''}>
                <img 
                    src={isActive ? item.activeIcon : item.icon} 
                    style={{ width: "21px", margin: '7px 0px 7px 7px' }} 
                    alt={item.alt} 
                />
            </CustomNavLink>
        );
    };

    return (
        <Cointainer className='noAfter'>
            <CustomDiv marginT="150px">
                {config.map((item, index) => {
                    const isActive = item.path && window.location.href.includes(item.path);
                    return item.path ? (
                        renderNavLink(item, isActive)
                    ) : (
                        <CustomNavLink1 key={index} to={item.path}>
                            <img 
                                src={item.icon} 
                                style={{ width: "21px", margin: '7px 0px 7px 7px' }} 
                                alt={item.alt} 
                            />
                        </CustomNavLink1>
                    );
                })}
            </CustomDiv>
        </Cointainer>
    );
};
